import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { PermissionEnum } from '@ui/src';
import { useAppSelector } from '@store';
import SettingsCalculatedForm from '../../../components/settings/calculated-form';
import { RiskScoreCalculationType, RiskScoreType } from '../../types';
import {
  useUpdateFactorMutation,
  useLazyGetFactorsQuery,
} from '../../../store/dictionaries/services';

import cn from '../transactions-risk.module.css';

const TransactionsRiskCalculation = () => {
  const {
    control: calculatedControl,
    handleSubmit: calculatedSubmit,
    reset: calculationReset,
  } = useForm<{
    calculationType: RiskScoreCalculationType;
  }>();

  const { factors, activePermissions } = useAppSelector(
    (state) => state.amlDictionaries,
  );

  const currentFactor = factors?.find(
    (item) => item.type === RiskScoreType.TRANSACTION_CALCULATION_RULE,
  );

  const [getFactors] = useLazyGetFactorsQuery();

  const [updateFactor, { isLoading: submitInProgress }] =
    useUpdateFactorMutation();

  const onCalculateSubmit = calculatedSubmit((formValues) => {
    if (currentFactor) {
      updateFactor({
        id: currentFactor?.id,
        body: {
          ...currentFactor,
          calculationType: formValues.calculationType,
        },
      });
    }
  });

  useEffect(() => {
    if (currentFactor) {
      calculationReset({ calculationType: currentFactor.calculationType });
    }
  }, [currentFactor, calculationReset]);

  useEffect(() => {
    if (!factors) {
      getFactors();
    }
  }, [factors]);

  return (
    <div className={cn.transactionsVolumesRisk}>
      <SettingsCalculatedForm
        control={calculatedControl}
        onSubmit={onCalculateSubmit}
        requestInProgress={submitInProgress}
        updateAllowed={activePermissions?.includes(
          PermissionEnum.SETTINGS_FACTORS_ACTION,
        )}
      />
    </div>
  );
};

export default TransactionsRiskCalculation;
